import { useMemo } from 'react';
import { jsonToMarkdown } from '../utils/converter';

/**
 * Custom hook for JSON to Markdown conversion
 */
export function useConverter(rawJson, options) {
  const parsed = useMemo(() => {
    if (!rawJson.trim()) {
      return { ok: false, data: null, error: "No JSON loaded yet." };
    }
    try {
      const obj = JSON.parse(rawJson);
      return { ok: true, data: obj, error: null };
    } catch (e) {
      return { ok: false, data: null, error: String(e) };
    }
  }, [rawJson]);

  const result = useMemo(() => {
    if (!parsed.ok || !parsed.data) {
      return { md: "", stats: null, error: parsed.error };
    }
    try {
      const converted = jsonToMarkdown(parsed.data, options);
      return { ...converted, error: null };
    } catch (e) {
      return {
        md: `<!-- Error during conversion: ${String(e)} -->`,
        stats: null,
        error: String(e),
      };
    }
  }, [parsed, options]);

  return result;
}
